import React from "react";
import { Link } from 'react-router-dom';
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box component="footer" sx={(theme) => ({
      mt: 10, py: 3, px: 2, textAlign: "center",
      backgroundColor: theme.palette.background.appbar,
      borderTop: "1px solid #ddd",
    })}>
      <Typography variant="body2" color="text.secondary">
        © ChainSpace |
        <Link to="/terms" style={{ color: "#888", margin: "0 4px", textDecoration: "none" }}>이용약관</Link> |
        <Link to="/privacy" style={{ color: "#888", margin: "0 4px", textDecoration: "none" }}>개인정보처리방침</Link> | 문의: 주지 마세요
      </Typography>
    </Box>
  );
};

export default Footer;